import React from 'react'
import { Dropdown } from 'react-bootstrap'

export const SubscriptionItem = () => {
	return (
		<Dropdown.Item target="_blank" href={`https://subscriptions.finlert.com/p/login/00gg2TcBq5lXbK05kk`}>
			Manage Subscriptions
		</Dropdown.Item>
	)
}
